/* Relax Master — Collectiepagina Bundels & Cadeaus: FAQ, scroll-naar-producten, add-to-cart.
   Review-filter + live WebwinkelKeur draait via rm-wwk-reviews.js (gedeeld). */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.rm-cadeau');
    if (!root) return;

    /* ---- Scroll naar #producten ---- */
    root.querySelectorAll('[data-rm-scroll-producten]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.getElementById('producten');
        if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      });
    });

    /* ---- FAQ accordeon (één tegelijk open) ---- */
    root.querySelectorAll('[data-rm-faq]').forEach(function (item) {
      var head = item.querySelector('[data-rm-faq-head]');
      if (!head) return;
      head.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        root.querySelectorAll('[data-rm-faq]').forEach(function (i) { i.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
      });
    });

    /* ---- Add-to-cart "+" ---- */
    root.querySelectorAll('[data-rm-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var multi = btn.getAttribute('data-multi') === 'true';
        var url = btn.getAttribute('data-url');
        var vid = btn.getAttribute('data-variant-id');
        if (multi || !vid) { if (url) window.location.href = url; return; }
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            btn.removeAttribute('aria-busy');
            if (res.ok) window.location.href = '/cart';
            else if (url) window.location.href = url;
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            if (url) window.location.href = url;
          });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
